export const BANNER_MSG_INSTALL_PLUGIN = {
  header: 'Looks like you haven’t installed the ClassHive browser plugin!',
  body: 'This is needed to automatically log you into your digital resources. Ask for help from an adult to do this.'
}

export const BANNER_MSG_UPDATE_PLUGIN = {
  header: 'Looks like you have an old version of the browser plugin installed!',
  body: 'The latest version is needed to make sure you have the best experience in all your apps. Ask for help from an adult to do this.'
}

export const LOADING_MSG_APP_LIST = 'Loading your hive now! Please wait or click the refresh button below.'
export const EMPTY_MSG_APP_LIST = 'No resources have been added to your account yet. Click the refresh button below to try again.'

export const NO_INTERNET_MESSAGE = 'No internet connection detected';
